<template>
  <v-container fluid class="ml-4 mt-4 px-4">
    <v-row align="center">
      <v-col cols="10" sm="8" lg="5" class="px-0">
        <v-card flat>
          <v-autocomplete
            v-model="model"
            :items="items"
            :loading="isLoading"
            :search-input.sync="search"
            color="white"
            hide-no-data
            hide-details
            hide-selected
            item-text="use"
            item-value="use"
            :label="$t('search.searchUse.label')"
            :placeholder="$t('search.searchUse.placeholder')"
            return-object
            outlined
            success
            @input="oneUseIsSelected(model.use)"
            @keydown.enter="searchAndDisplay(search)"
          ></v-autocomplete>
        </v-card>
      </v-col>
      <v-col class="ml-4">
        <h2 class="text-h5" v-if="showResult">
          {{ substancesToDisplay.length }}
          {{ $t("search.searchUse.matchNumber") }}
          '{{ query }}'
        </h2>
      </v-col>
    </v-row>
    <v-row justify="start">
      <v-col cols="10" v-if="showResult">
        <v-card flat>
          <v-row
            class="my-4"
            v-for="(substance, n) in substancesToDisplay"
            :key="n"
          >
            <substance-card-use
              :subItem="substance"
              :queries="query"
            ></substance-card-use>
          </v-row>
        </v-card>
      </v-col>
      <v-col cols="12" v-else>
        <v-skeleton-loader
          v-if="isLoading"
          type="article, article, article, article, article"
        ></v-skeleton-loader>
        <div v-if="noResult">{{ $t("search.searchUse.noResult") }}</div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import SubstanceCardUse from "../components/SubstanceCardUse.vue";
import { monitore } from "../components/helpers/helpers";
import { mapGetters, mapMutations } from "vuex";

export default {
  data: () => ({
    isLoading: false,
    noResult: false,
    model: null,
    search: null,
    query: "",
    queryType: "",

    items: [],
    substances: [],
    substancesToDisplay: [],

    showResult: false,
    processResult: false,
  }),
  components: {
    SubstanceCardUse,
  },
  computed: {
    ...mapGetters(["currentPage", "lastPage"]),
  },

  watch: {
    search(val) {
      if (this.processResult) {
        this.items = [];
      } else {
        // Si 3 caract
        if (val.length > 2) {
          // Go get uses
          this.isLoading = true;
          this.noResult = false;
          this.showResult = false;

          this.substances = [];
          this.substancesToDisplay = [];
          this.getItems(val);
        }
      }
    },
  },
  async beforeMount() {
    if (this.currentPage.name === this.$route.name) {
      if (this.currentPage.params.query) {
        this.$route.params.query = this.currentPage.params.query;
        this.$route.params.queryType = this.currentPage.params.queryType;
        if (this.$route.params.queryType === "find") {
          await this.oneUseIsSelected(this.$route.params.query);
        } else {
          await this.searchAndDisplay(this.$route.params.query);
        }
      }
    } else if (this.lastPage.name === this.$route.name) {
      if (this.lastPage.params.query) {
        this.$route.params.query = this.lastPage.params.query;
        this.$route.params.queryType = this.lastPage.params.queryType;
        if (this.$route.params.queryType === "find") {
          await this.oneUseIsSelected(this.$route.params.query);
        } else {
          await this.searchAndDisplay(this.$route.params.query);
        }
      }
    }
    this.setCurrentPage({
      name: this.$route.name,
      params: this.$route.params,
    });
  },
  methods: {
    ...mapMutations(["setCurrentPage"]),
    // Get Item for the autocompletion component
    async getItems(value) {
      let url = "/substances";
      this.isLoading = true;
      try {
        var response = await this.axios.get(url, {
          params: { critere: "usescase", value: value },
        });
        this.substances = response.data;
        if (this.substances.length) {
          this.substances.forEach((sub) => {
            sub.usescase.forEach((use) => {
              this.items.push({
                use: use,
              });
            });
          });
          this.isLoading = false;
        } else {
          this.isLoading = false;
          this.noResult = true;
        }
      } catch (err) {
        console.log(err);
      }
    },
    // function to search substances when clic on enter or select an item
    async searchSubstances(critere, value, type) {
      let url = "/substances";
      let substancesResult = [];
      this.query = value;
      try {
        var response = await this.axios.get(url, {
          params: { critere: critere, value: value, type: type },
        });
        if (response.data.length) {
          substancesResult = response.data;
        }
        return substancesResult;
      } catch (err) {
        console.log(err);
      }
    },
    // when clic on enter search all substances with the query value
    async searchAndDisplay(searchQuery) {
      if (!this.noResult) {
        this.processResult = true;
        this.substancesToDisplay = await this.searchSubstances(
          "usescase",
          searchQuery
        );
        if (this.substancesToDisplay.length) {
          this.search = null;
          this.items = [];
          this.showResult = true;
          this.queryType = "";

          this.setCurrentPage({
            name: this.$route.name,
            params: { query: searchQuery, queryType: "" },
          });
          monitore("Search substance", {
            critere: "usescase",
            value: searchQuery,
          });
        } else {
          this.noResult = true;
        }
        this.processResult = false;
      }
    },
    // when clic on an item search all substances with this item
    async oneUseIsSelected(searchQuery) {
      this.processResult = true;
      this.substancesToDisplay = await this.searchSubstances(
        "usescase",
        searchQuery,
        "find"
      );
      this.search = null;
      this.items = [];
      this.showResult = true;
      this.processResult = false;
      this.queryType = "find";
      this.setCurrentPage({
        name: this.$route.name,
        params: { query: searchQuery, queryType: "find" },
      });
      monitore("Search substance", {
        critere: "usescase",
        value: searchQuery,
      });
    },
  },
};
</script>
